import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faGithub } from '@fortawesome/free-brands-svg-icons'

const Footer = () => (
  <Wrapper>
    <WrapperInner>
        <StyledLink to="/">
          <SiteTitle>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 545.02 84.42"><g data-name="レイヤー 2"><g data-name="レイヤー 1"><path d="M523.55 65.13c-18 .1-28.65-13.43-24.53-28.79 2.37-8.83 9.53-14.67 20.14-15.65 8.79-.81 16.61 1.79 21.8 9.36 5 7.28 5.3 15.29 1.35 23.1a21.24 21.24 0 0 1-18.76 11.98zm-2.09-33.2c-5.81 0-10 4.39-10 10.66s4.27 11.07 10 11.16 10.12-4.61 10.17-10.93-4.27-10.89-10.17-10.89zM458.41 84.42l-5.87-1.26c.49-3.73.95-7.27 1.43-10.93a7.08 7.08 0 0 1 1.55-.06c8.15 1.6 9.12-2.79 11.07-8.17.31-.84-.21-2.09-.61-3q-7.39-17.55-14.87-35.07c-.49-1.16-.95-2.32-1.6-3.91 4.93 0 9.49-.09 14 .1.65 0 1.52 1.31 1.83 2.17 2.57 7.17 5 14.38 7.55 21.57.3.87.66 1.72 1.28 3.31.73-2.15 1.26-3.57 1.7-5 2-6.63 4.12-13.24 6.09-19.89.49-1.64 1.24-2.37 3.05-2.31 3.9.13 7.8 0 12.1 0-.75 2.06-1.34 3.77-2 5.46q-8.16 21-16.36 42.05c-.57 1.45-1.23 2.87-1.86 4.3-2.86 6.57-8.2 9.63-15 10.66zM402.26 0h12c2.08 0 1.56 1.64 1.56 2.79v35.46l.69.3c2-2.55 4-5.13 6-7.65 2.39-3 4.29-7 7.4-8.5s7.28-.42 11-.46h5.21l-16.09 18.9 16.8 23c-5.76 0-10.9.07-16-.08-.72 0-1.57-1-2.08-1.73-3.58-5.14-7.08-10.34-10.62-15.5-.53-.78-1.13-1.51-2.24-3v20.11h-13.63zM371.16 65.17c-8.4-.31-16.08-3.85-20.08-12.71-3.77-8.36-3.07-16.66 2.83-24 7.64-9.49 24.18-10.68 34-2.62 9 7.37 10.33 21.65 2.84 30.9-4.75 5.88-11.14 8.36-19.59 8.43zm1-33.24c-5.8 0-9.95 4.46-10 10.7s4.32 11.07 10 11.12 10.09-4.64 10.12-11-4.28-10.83-10.14-10.82zM320.21 11.07h13.37V22c2.57 0 4.87.09 7.16 0 2-.11 2.87.5 2.75 2.62-.15 2.33 0 4.68 0 7.38h-9.63c0 6.47-.17 12.6.07 18.7.11 2.69 2.36 3.66 4.84 3.7a38.72 38.72 0 0 0 4-.37v9.68c-5.18 1.63-10.53 2-15.77-.32-4.82-2.12-6.44-6.38-6.63-11.21-.21-5.47-.08-11-.1-16.44v-3.52h-6.7v-9.9c.63-.11 1.09-.24 1.56-.27 5.07-.29 5.07-.29 5.07-5.54zM309.73 56.63a8 8 0 0 1-8.33 8c-4.81 0-8.67-3.76-8.53-8.23a8.54 8.54 0 0 1 8.79-8.06 8 8 0 0 1 8.07 8.29zM284.35 63.73h-13.86v-3.15V41.8a23.66 23.66 0 0 0-.28-4.38c-.56-2.75-1.8-5-5-5.37s-6 .81-7.26 3.75a16.48 16.48 0 0 0-1.2 5.94c-.14 7.22-.05 14.44-.05 21.87H243V22.25h13.05v5.48l1.8-2c4.35-4.79 9.84-5.9 15.81-4.39 5.8 1.47 9.07 5.68 10 11.43a72 72 0 0 1 .63 10.8c.13 6.64.06 13.27.06 20.16zM230.68 63.71h-13.35c-.07-.94-.19-1.8-.19-2.65 0-12 .06-24.06-.06-36.09 0-2.52.83-3.19 3.2-3.07 3.4.17 6.81 0 10.4 0zM224.07 15.78c-4.45.05-7.79-3-7.85-7.27a7.45 7.45 0 0 1 7.55-7.6c4.54-.09 8.06 3.15 8.07 7.43a7.53 7.53 0 0 1-7.77 7.44zM179.43 27.34c3.82-4.73 7.89-6.81 13.09-6.57 7.28.34 12.88 4.05 13.67 11.26 1.15 10.44 1 21 1.36 31.67H193.4v-3.07-19.68c0-5.8-2-8.66-6-8.84-4.52-.21-7.66 3-7.84 8.7-.22 6.95-.08 13.91-.11 20.86 0 .58-.11 1.15-.19 1.93H166V0c4 0 8.11-.08 12.17.11.47 0 1.22 1.55 1.24 2.39.1 7 0 13.91.06 20.86zM158.59 26.64l-7.67 7a9.49 9.49 0 0 0-2.12-1.35 29.56 29.56 0 0 0-6.65-1.9c-2.11-.2-4.6.29-5 3s2.12 3.15 4 3.75c2.89.9 5.9 1.47 8.7 2.57 4.77 1.87 8 5.07 8.25 10.64.22 6-2.41 10.15-7.69 12.69-8.4 4.06-21.74 2-28.29-4.45l6.88-7.12c3.59 1.4 6.68 2.73 9.85 3.76a4.69 4.69 0 0 0 3.42-.28c1.14-.65 2.57-1.89 2.65-3a4.2 4.2 0 0 0-2.17-3.26c-3.34-1.34-6.93-2-10.31-3.29-6.77-2.53-9.68-8.78-7.15-15.4a13.7 13.7 0 0 1 3.23-4.8c7.14-6.75 23.06-6.04 30.07 1.44zM95.12 65.14c-13.43 0-23.29-9.32-23.36-22.2s9.5-22.31 23.07-22.44 23.37 9.05 23.49 22-9.62 22.58-23.2 22.64zm-10-22.44c0 6.37 4.24 11 10 11s10.11-4.79 10.1-11-4.4-10.83-10.29-10.78-9.84 4.44-9.84 10.78zM33.47 53.27c-5.58 0-9.78-4.43-9.88-10.49s4-10.63 9.63-10.67 10.15 4.61 10.07 10.61-4.21 10.53-9.82 10.55z"></path><path d="M35.93 3.49C19.75 1.9 4.15 13.52.78 29.65c-.21 1-.52 2-.78 3.05v7.64a8.82 8.82 0 0 1 .59 1.6A33.1 33.1 0 1 0 35.93 3.49zm-2.67 62C19.34 65.3 9.88 55.75 9.92 41.91c0-12.61 9.92-21.75 23.46-21.73 13.9 0 23.67 9.38 23.63 22.59C57 55.75 46.64 65.6 33.26 65.45z"></path></g></g></svg>
          </SiteTitle>
        </StyledLink>
        <Year>© 2014-{new Date().getFullYear()}</Year>
        <Links>
          <Link to="/privacy">プライバシーポリシー</Link>
          <a href="https://twitter.com/drumroll_tokyo"><FontAwesomeIcon icon={faTwitter}/></a>
          <a href="https://github.com/oooshinnn"><FontAwesomeIcon icon={faGithub}/></a>
        </Links>
        <Licence>I customized the wicked cool background on my homepage at <a href="https://www.svgbackgrounds.com" target="_blank" rel="noopener noreferrer">SVGBackgrounds.com.</a></Licence>
    </WrapperInner>
  </Wrapper>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

const Wrapper = styled.footer`
  background-color: #333231;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='84' height='42' viewBox='0 0 84 42'%3E%3Cdefs%3E%3Crect stroke='%23333231' stroke-width='0.1' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='2' height='2' patternUnits='userSpaceOnUse'%3E%3Cg stroke='%23333231' stroke-width='0.1'%3E%3Crect fill='%23373635' width='1' height='1'/%3E%3Crect fill='%23333231' width='1' height='1' x='1' y='1'/%3E%3Crect fill='%233b3a39' width='1' height='1' y='1'/%3E%3Crect fill='%233f3e3d' width='1' height='1' x='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='b' width='5' height='11' patternUnits='userSpaceOnUse'%3E%3Cg fill='%23434241'%3E%3Cuse xlink:href='%23s' x='2' y='0'/%3E%3Cuse xlink:href='%23s' x='4' y='1'/%3E%3Cuse xlink:href='%23s' x='1' y='2'/%3E%3Cuse xlink:href='%23s' x='2' y='4'/%3E%3Cuse xlink:href='%23s' x='4' y='6'/%3E%3Cuse xlink:href='%23s' x='0' y='8'/%3E%3Cuse xlink:href='%23s' x='3' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='7' height='7' patternUnits='userSpaceOnUse'%3E%3Cg fill='%23474746'%3E%3Cuse xlink:href='%23s' x='1' y='1'/%3E%3Cuse xlink:href='%23s' x='3' y='4'/%3E%3Cuse xlink:href='%23s' x='5' y='6'/%3E%3Cuse xlink:href='%23s' x='0' y='3'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='11' height='5' patternUnits='userSpaceOnUse'%3E%3Cg fill='%23333231'%3E%3Cuse xlink:href='%23s' x='1' y='1'/%3E%3Cuse xlink:href='%23s' x='6' y='3'/%3E%3Cuse xlink:href='%23s' x='8' y='2'/%3E%3Cuse xlink:href='%23s' x='3' y='0'/%3E%3Cuse xlink:href='%23s' x='0' y='3'/%3E%3C/g%3E%3Cg fill='%234b4b4a'%3E%3Cuse xlink:href='%23s' x='8' y='3'/%3E%3Cuse xlink:href='%23s' x='4' y='2'/%3E%3Cuse xlink:href='%23s' x='5' y='4'/%3E%3Cuse xlink:href='%23s' x='10' y='0'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='23' patternUnits='userSpaceOnUse'%3E%3Cg fill='%23ff6f61'%3E%3Cuse xlink:href='%23s' x='2' y='5'/%3E%3Cuse xlink:href='%23s' x='23' y='13'/%3E%3Cuse xlink:href='%23s' x='4' y='18'/%3E%3Cuse xlink:href='%23s' x='35' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='61' height='31' patternUnits='userSpaceOnUse'%3E%3Cg fill='%23ff6f61'%3E%3Cuse xlink:href='%23s' x='16' y='0'/%3E%3Cuse xlink:href='%23s' x='13' y='22'/%3E%3Cuse xlink:href='%23s' x='44' y='15'/%3E%3Cuse xlink:href='%23s' x='12' y='11'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='84' height='42'/%3E%3Crect fill='url(%23b)' width='84' height='42'/%3E%3Crect fill='url(%23c)' width='84' height='42'/%3E%3Crect fill='url(%23d)' width='84' height='42'/%3E%3Crect fill='url(%23e)' width='84' height='42'/%3E%3Crect fill='url(%23f)' width='84' height='42'/%3E%3C/svg%3E");
  background-size: 200%;
  background-attachment: fixed;
`

const WrapperInner = styled.div`
  margin: 0 auto;
  max-width: 960;
  padding: 1.45rem 1.0875rem;
  color: #fff;
`

const SiteTitle = styled.p`
  margin: 0 auto;
  fill: #fff;
  width: 150px;
`

const Year = styled.p`
  font-size: .7rem;
  margin: 0;
  text-align: center;
`

const Licence = styled.p`
  font-size: .7rem;
  margin: 0;
  text-align: center;

  a {
    color: #fff;

    &:hover {
      text-decoration: none;
      color: #4078c0;
    }
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: none;
    color: #4078c0;

    svg {
      fill: #4078c0;
    }
  }
`

const Links = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    font-size: .8rem;
    margin: 5px;
    color: inherit;

    &:hover {
      text-decoration: none;
      color: #4078c0;
    }
  }
`

export default Footer
